var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 446,
    viewBox: "0 0 980 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M865.243 445.03C833 301.5 641 216.838 457.5 196.5C136.5 160.923 52.2896 -1.96997 52.2896 -1.96997",
    stroke: "#001F8E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "10 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.656 381.7C54.282 399.03 28.656 347.03 28.656 347.03",
    stroke: "#F3F9FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.346 289.32C977.306 261.63 945.146 242.03 945.146 242.03",
    stroke: "#F3F9FF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 979.346,
    height: 445.12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsArrow);
export default __webpack_public_path__ + "static/media/StepsArrow.6265c42ca54d2861118bc496a957a3c2.svg";
export { ForwardRef as ReactComponent };